import { brregProvider } from "./brreg"
import { nominatimProvider } from "./nominatim"
import type { DataSourceProvider } from "./types"

/** Registry of available data source providers, keyed by provider name. */
const dataSourceProviders: Record<string, DataSourceProvider> = {
  brreg: brregProvider,
  nominatim: nominatimProvider,
}

/** Look up a data source provider by its registry key. */
export function getDataSourceProvider(providerName: string): DataSourceProvider | undefined {
  return dataSourceProviders[providerName]
}
